import { Component, inject, input } from '@angular/core';
import { SiModalService } from '@siemens/element-ng/modal';
import { TranslatePipe } from '@ngx-translate/core';
import { SiIconComponent } from '@siemens/element-ng/icon';
import type { ILocation } from '../../../../../shared/interfaces/ILocation';
import { PrintLocationInfoComponent } from './print-location-info/print-location-info.component';

@Component({
    selector: 'app-tab-downloads',
    templateUrl: './tab-downloads.component.html',
    styleUrls: ['./tab-downloads.component.scss'],
    imports: [TranslatePipe, SiIconComponent]
})
export class TabDownloadsComponent {
    private dialog = inject(SiModalService);

    public readonly location = input.required<ILocation>();

    public printLocationInfo(): void {
        this.dialog.show(
            PrintLocationInfoComponent,
            {
                inputValues: { data: this.location() },
                ignoreBackdropClick: false,
                keyboard: true,
                animated: true,
                class: 'modal-lg',
                ariaLabelledBy: 'print-location-dialog-title'
            },
            'close'
        );
    }
}
